import { useEffect, useState } from 'react'

import AdventureTime1 from '@/assets/ads/ATCW2025_Launch_3Boxes-Jake-Finn-CardGamer.png'
import AdventureTime2 from '@/assets/ads/ATCW2025_Launch_Floop-Jake-Finn-CardGamer.png'
import MY_IMAGE from '@/assets/ads/f2f.png'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { useLoadAds } from '@/contexts/ads'
import { useAppSelector } from '@/store/hooks'

import styles from './MidBanner.module.scss'

// Note: (un)comment CSS if separate mobile ad (not) provided

const MidBanner = () => {
  const userRegion = useAppSelector((state) => state?.user.region)
  const loadAds = useLoadAds()
  const [headsOrTails, setHeadsOrTails] = useState<boolean>(true)

  useEffect(() => {
    setHeadsOrTails(Math.random() < 0.5)
  }, [])

  // https://www.epochconverter.com
  const f2fEnabled = userRegion === 'CA' && Date.now() < 1739703540000 // Date.now() >= 1732888800000 && Date.now() < 1733187600000
  const adventureTimeEnabled = !f2fEnabled && Date.now() < 1740686400000
  const enabled = f2fEnabled || adventureTimeEnabled

  if (!enabled || loadAds !== true) return null

  return (
    <div className={styles.container}>
      {f2fEnabled ? (
        <OutboundLink
          className={styles.link}
          url='https://www.facetofacegames.com/magic/?utm_source=edhrec&utm_medium=affiliate'
        >
          {/* <img className='d-none d-sm-block' src={MY_IMAGE.src} alt='MY ALT' />
        <img className='d-sm-none' src={MY_IMAGE.src} alt='MY ALT' /> */}
          <img src={MY_IMAGE.src} alt='Face to Face Games' />
        </OutboundLink>
      ) : (
        <OutboundLink
          className={styles.link}
          url='https://www.kickstarter.com/projects/cze/adventure-time-card-wars-2025?ref=ajqlq8'
        >
          <img src={headsOrTails ? AdventureTime1.src : AdventureTime2.src} alt='Face to Face Games' />
        </OutboundLink>
      )}
    </div>
  )
}

export default MidBanner
